import React, { Component } from "react";

export default class Contact extends Component {
constructor(){
super()
this.state = {
  name: '',
  phone: '',
  email: '',
  message: '',
}
}
  handleChange = (event) => {
    const {name, value} = event.target
    this.setState({
      [name]: value
    })
  }
  handleSubmit = () => {
    this.setState({
      name: '',
      phone: '',
      email: '',
      message: '',

    })
    alert("Thank you very much for yours message!")
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div>
        <div className="contact-parallax parallax d-flex justify-content-center align-items-center">
          <h1 className="main-photo-text">Contact</h1>
        </div>
        <div className="container">
          <div className="row justify-content-around">
            <form className="col-12 mt-3" onSubmit={() => this.handleSubmit()}>
              <h3 className="text-center">Write to us!</h3>
              <div className="row justify-content-between mt-3">
                <input
                  type="text"
                  name='name'
                  placeholder="Yours name"
                  className="col-12 col-md-4 contact-input"
                  value={this.state.name}
                  onChange={(event) => this.handleChange(event)}
                />
                <input
                  type="tel"
                  name='phone'
                  className="col-12 col-md-3 contact-input"
                  placeholder="Yours phone"
                  value={this.state.phone}
                  onChange={(event) => this.handleChange(event)}
                />
                <input
                  type="email"
                  name='email'
                  placeholder="Yours e-mail"
                  className="col-12 col-md-4 contact-input"
                  value={this.state.email}
                  onChange={(event) => this.handleChange(event)}
                />
                <textarea
                  placeholder="Yours message"
                  name='message'
                  rows="10"
                  className="col-12 mt-3"
                  value={this.state.message}
                  onChange={(event) => this.handleChange(event)}
                />
                <button className="btn btn-success col-2 mt-3 offset-10">
                  Submit
                </button>
              </div>
            </form>
            <div className="col-12 my-3">
              <h3 className="text-center mb-3">Call us!</h3>
              <div className="d-flex justify-content-around">
                <div className="d-flex mx-2 flex-column align-items-center">
                  <h5>Office </h5>
                  <div className="d-flex">
                    <i className="fas fa-phone mx-2" />
                    <h5>+1 123 456 789</h5>
                  </div>
                </div>
                <div className="d-flex mx-2 flex-column align-items-center">
                  <h5>Customer service manager</h5>
                  <div className="d-flex justify-content-center">
                    <i className="fas fa-phone mx-2" />
                    <h5>+1 123 456 891</h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 my-3">
              <h3 className="text-center">Visit us!</h3>
              <div className="d-flex justify-content-around">
                <div className="d-flex">
                  <i className="fas fa-map-marker mr-4 align-self-center" />
                  <div className="align-self-center">
                    <h5>Poole Edge 123</h5>
                    <h5> Fairbanks, United States</h5>
                  </div>
                </div>
                <div className="d-flex">
                  <h4 className="mr-3 align-self-center">
                    <i className="far fa-clock" />
                  </h4>
                  <div className="d-flex flex-column align-self-center">
                    <h6>Monday-Friday: 08:00-16:00 </h6>
                    <h6>Saturday: 10:00-16:00 </h6>
                    <h6>Sunday: Closed </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
